import React from "react";
import { PdfImg, TrashIconGray } from "../../constant/imagePath";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import { Button } from "../Button/Button";
import classes from "./CertificateInformationCard.module.css";

function CertificateInformationCard({ data, onDelete }) {
  return (
    <div className={` ${classes.certificationsbox}`}>
      <div>
        <img
          src={
            data?.certificateImg?.type.split("/")[1] == "pdf"
              ? PdfImg
              : URL.createObjectURL(data?.certificateImg)
          }
          alt="..."
          className={`${classes.certificateimg}`}
        />
        <div>
          <h6
            style={{
              ...Fonts.h7,
              colors: Colors.neutralShadesOfNero,
              lineHeight: "24px",
              fontFamily: "inter-600",
            }}
            className={`${classes.mb8}`}
          >
            {data?.title}
          </h6>

          <div>
            <span
              style={{
                ...Fonts.p2,
                color: Colors.neutralShadesOfDimGray,
              }}
            >
              {data?.size}mb
            </span>
            <p
              style={{
                backgroundColor: Colors.neutralShadesOfPinkSwan,
              }}
              className={`${classes.dot}`}
            ></p>
            <span
              style={{
                ...Fonts.p2,
                color: Colors.neutralShadesOfDimGray,
              }}
            >
              {data?.date}
            </span>
          </div>
        </div>
      </div>
      <div>
        <Button
          primary={false}
          icon={TrashIconGray}
          size={"Small"}
          onClick={() => onDelete(data?._id)}
        />
      </div>
    </div>
  );
}

export default CertificateInformationCard;
